import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import HrbTranslate from '../../../../components/language/HrbTranslate';
import '../../ReassignQueuePage.scss'
import classNames from 'classnames'
import LoadingSpinner from "../../../../components/library/loaders/LoadingSpinnerSmall"

const ReassignConfirmationModal = ({ onClose, textContent, handleBulkReassignment, isLoading }) => {
    const language = useSelector(state => (state.layout.lang || 'EN').toUpperCase())
    return (
        <div className='reassign-modal-background'>
            <div className={classNames('reassign-modal-container', { 'adjust-fr-height': language === 'FR' })}>
                <div className='reassign-modal-content'>
                    <div className='reassign-confirmation-modal-text'>
                        {textContent}
                    </div>
                    <div className='reassign-confirmation-modal-bottom-panel'>
                        <div className='reassign-confirmation-modal-cancel' onClick={!isLoading ? onClose : null}>
                            <HrbTranslate className='reassign-confirmation-modal-cancel-text' text={'QueuePage.Labels.ReassignModalCancel'} />
                        </div>
                        <div className='reassign-confirmation-modal-confirm' onClick={!isLoading ? handleBulkReassignment : null}>
                            {isLoading ? 
                                <LoadingSpinner />
                                :
                                <HrbTranslate className='reassign-confirmation-modal-confirm-text' text={'QueuePage.Labels.ReassignModalConfirm'} />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReassignConfirmationModal;